// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wrghlmsinvhwvvfhhrvj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndyZ2hsbXNpbnZod3Z2ZmhocnZqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk2NjM1MjYsImV4cCI6MjA1NTIzOTUyNn0.tbrRVTXU14RgHEQVDjVLLLteuH9f1nOvcHLEbgQDXQM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);